// Конфигурация колонок «Данные сотрудника» для отчёта по талонам.
// Значения берутся из колонок ответа meta_<key> (сервер раскладывает external_data
// через ->>). id_sotr = табельный номер. Порядок = порядок отображения.
// eslint-disable-next-line import/prefer-default-export
export const employeeMetaColumns = [
  { key: 'fio', title: 'ФИО', width: 200 },
  { key: 'id_sotr', title: 'Табельный номер', width: 150 },
  { key: 'departament', title: 'Департамент', width: 220 },
  { key: 'podrazdelenie', title: 'Подразделение', width: 240 },
  { key: 'doljnost', title: 'Должность', width: 200 },
];
